import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Filter } from '@budget-monorepo/shared-ui';

const AppropriationFilter = ({ path }) => {
  const { filterData } = useStaticQuery(
    graphql`
        query {
          filterData: pagesJson(fields: {slug: { eq: "/line-item/"}}) {
            lineItems {
              lineItemNumber
              lineItemName
              govLevelTwo
              govLevelOne
              govLevelThree
              govLevelTwoFull
              govLevelOneFull
              govLevelThreeFull
              govLevelTwoAbbr
              govLevelOneAbbr
              govLevelThreeAbbr
            }
          }
        }
      `
  );

  const newFilterOptions = [];
  let i = 0;
  const dataLength = filterData.lineItems.length;
  for (; i < dataLength; i += 1) {
    const item = filterData.lineItems[i]; // target
    const newFields = {
      account: item.lineItemNumber,
      description: item.lineItemName,
      govLevelOneDisplay: item.govLevelOneFull,
      govLevelTwoDisplay: item.govLevelTwoFull,
      govLevelThreeDisplay: item.govLevelThreeFull
    }; // source
    // normalize filter data by adding account and description fields
    newFilterOptions.push(Object.assign(item, newFields));
  }

  const filterProps = {
    path,
    pathRoot: '/enacted/',
    filterData: newFilterOptions,
    fuzzyDisplay: {
      label: 'Search for a line item',
      id: 'line-item-search',
      inputId: 'line-item-search-input',
      placeholder: 'Enter line item number or name'
    },
    orgDisplay: {
      label: 'Search by a state organization',
      id: 'state-organization',
      inputId: 'state-organization-input',
      placeholder: 'Enter a state organization'
    }
  };

  return<Filter {...filterProps} />;
};

AppropriationFilter.propTypes = {
  path: PropTypes.string,
  filterData: PropTypes.array
};

export default AppropriationFilter;
